import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { CheckIncustomerConstant } from "./CheckInCustomerConstant";

const initialState = {
  CheckIncustomerList: [],
  getcheckinCustomerbyid:[],
  addcheckindetails:[],
  CheckIncustomerTableLoading: {
    isLoading: false,
  },
};

export const CheckIncustomerReducer = persistReducer(
  {
    storage,
    key: "CheckIncustomerTable",
    whitelist: [" CheckIncustomerList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case CheckIncustomerConstant.CHECKIN_CUSTOMER_REQUEST: {
        return {
          ...state,
          CheckIncustomerList: [],
          CheckIncustomerTableLoading: {
            isLoading: true,
          },
        };
      }

      case CheckIncustomerConstant.CHECKIN_CUSTOMER_RESPONSE: {
        return {
          ...state,
          CheckIncustomerList: payload,
          CheckIncustomerTableLoading: {
            isLoading: false,
          },
        };
      }
      
      case CheckIncustomerConstant.ADD_CHECKIN_CUSTOMER_DETAIL_RESPONSE: {
        return {
          ...state,
          addcheckindetails: payload,
          CheckIncustomerTable: {
            isLoading: false,
          },
        };
      }
      case CheckIncustomerConstant.ADD_CHECKIN_CUSTOMER_DETAIL_REQUEST: {
        return {
          ...state,
          addcheckindetails: [],
          CheckIncustomerTable: {
            isLoading: true,
          },
        };
      }
      case CheckIncustomerConstant.CHECKIN_CUSTOMER_DETAILS_BY_ID_RESPONSE: {
        return {
          ...state,
          getcheckinCustomerbyid: payload,
          CheckIncustomerTable: {
            isLoading: false,
          },
        };
      }
      case CheckIncustomerConstant.CHECKIN_CUSTOMER_DETAILS_BY_ID_REQUEST: {
        return {
          ...state,
          getcheckinCustomerbyid: [],
          CheckIncustomerTable: {
            isLoading: true,
          },
        };
      }

      default:
        return state;
    }
  }
);
